import {React, useEffect, useState, useContext} from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import GlobalContext from "../context/GlobalContext.js";
import ResetPasswordAPI from '../functions/API/ResetPasswordAPI';
import PasswordStrengthChecker from '../components/PasswordStrengthChecker';
import Modal from 'react-modal';

export default function ResetPassword(props) {

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();  
  const { token } = useParams();
  const [loadingspinner, setLoadingSpinner] = useState(false);
  const [passwordSecure, setPasswordSecure] = useState(false);
  const {theme, updateTheme, themeCSS, settings} = useContext(GlobalContext)
  const [accessibilityModal, setAccessibilityModal] = useState(false);

  async function resetPW() {
    setLoadingSpinner(true)
    if(!passwordSecure){
      toast.error("Your password does not meet the minimum requirements");
      setLoadingSpinner(false);
      return
    }
    if(password === confirmPassword) {
      const ResetResponse = await ResetPasswordAPI(email, token, password, confirmPassword);
      if(ResetResponse.response.status === 200){
        toast.success('Your password has been reset - redirecting to login')
        setTimeout(function(){
          window.location.href = '/login';
        }, 3000);
      } else {
        toast.error("Password reset failed. Please try again.");
      }
    } else {
      toast.error("Passwords don't match!");
    }
    setLoadingSpinner(false)
  }

  function emailChange(event) {
    setEmail(event.target.value);
  }

  function passwordChange(event) {
    setPassword(event.target.value);
  }

  function confirmPasswordChange(event) {
    setConfirmPassword(event.target.value);
  }

  return (
    <>
    <div className={"min-h-screen py-1 " + (themeCSS.divCSS)}>
      <button onClick={() => {setAccessibilityModal(true)}} className="absolute top-2 right-0 mr-10 w-4 mb-10 rounded-fulle grid grid-cols-12">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.8199 22H10.1799C9.71003 22 9.30347 21.673 9.20292 21.214L8.79592 19.33C8.25297 19.0921 7.73814 18.7946 7.26092 18.443L5.42392 19.028C4.97592 19.1709 4.48891 18.9823 4.25392 18.575L2.42992 15.424C2.19751 15.0165 2.27758 14.5025 2.62292 14.185L4.04792 12.885C3.98312 12.2961 3.98312 11.7019 4.04792 11.113L2.62292 9.816C2.27707 9.49837 2.19697 8.98372 2.42992 8.576L4.24992 5.423C4.48491 5.0157 4.97192 4.82714 5.41992 4.97L7.25692 5.555C7.50098 5.37416 7.75505 5.20722 8.01792 5.055C8.27026 4.91269 8.52995 4.78385 8.79592 4.669L9.20392 2.787C9.30399 2.32797 9.71011 2.00049 10.1799 2H13.8199C14.2897 2.00049 14.6958 2.32797 14.7959 2.787L15.2079 4.67C15.4887 4.79352 15.7622 4.93308 16.0269 5.088C16.2739 5.23081 16.5126 5.38739 16.7419 5.557L18.5799 4.972C19.0276 4.82967 19.514 5.01816 19.7489 5.425L21.5689 8.578C21.8013 8.98548 21.7213 9.49951 21.3759 9.817L19.9509 11.117C20.0157 11.7059 20.0157 12.3001 19.9509 12.889L21.3759 14.189C21.7213 14.5065 21.8013 15.0205 21.5689 15.428L19.7489 18.581C19.514 18.9878 19.0276 19.1763 18.5799 19.034L16.7419 18.449C16.5093 18.6203 16.2677 18.7789 16.0179 18.924C15.7557 19.0759 15.4853 19.2131 15.2079 19.335L14.7959 21.214C14.6954 21.6726 14.2894 21.9996 13.8199 22ZM7.61992 16.229L8.43992 16.829C8.62477 16.9652 8.81743 17.0904 9.01692 17.204C9.20462 17.3127 9.39788 17.4115 9.59592 17.5L10.5289 17.909L10.9859 20H13.0159L13.4729 17.908L14.4059 17.499C14.8132 17.3194 15.1998 17.0961 15.5589 16.833L16.3799 16.233L18.4209 16.883L19.4359 15.125L17.8529 13.682L17.9649 12.67C18.0141 12.2274 18.0141 11.7806 17.9649 11.338L17.8529 10.326L19.4369 8.88L18.4209 7.121L16.3799 7.771L15.5589 7.171C15.1997 6.90671 14.8132 6.68175 14.4059 6.5L13.4729 6.091L13.0159 4H10.9859L10.5269 6.092L9.59592 6.5C9.39772 6.58704 9.20444 6.68486 9.01692 6.793C8.81866 6.90633 8.62701 7.03086 8.44292 7.166L7.62192 7.766L5.58192 7.116L4.56492 8.88L6.14792 10.321L6.03592 11.334C5.98672 11.7766 5.98672 12.2234 6.03592 12.666L6.14792 13.678L4.56492 15.121L5.57992 16.879L7.61992 16.229ZM11.9959 16C9.78678 16 7.99592 14.2091 7.99592 12C7.99592 9.79086 9.78678 8 11.9959 8C14.2051 8 15.9959 9.79086 15.9959 12C15.9932 14.208 14.2039 15.9972 11.9959 16ZM11.9959 10C10.9033 10.0011 10.0138 10.8788 9.99815 11.9713C9.98249 13.0638 10.8465 13.9667 11.9386 13.9991C13.0307 14.0315 13.9468 13.1815 13.9959 12.09V12.49V12C13.9959 10.8954 13.1005 10 11.9959 10Z" fill={(themeCSS.iconHex)}></path>
        </svg>
    </button>
    <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-sm space-y-10 mt-10">
        <div>
          {settings.logo_url && (
            <img 
              src={theme === 'dark' && settings.dark_mode_logo_url ? settings.dark_mode_logo_url : settings.logo_url}
              alt="logo"
              width="180"
            className="mx-auto pb-2"
            />
          )}
          {!settings.logo_url && (
            <h1 className="pb-2 text-3xl font-semibold text-center">{settings.company_name}</h1>
          )}

          {!!settings.test_system && (
            <div className="flex justify-center">
              <div className="inline-flex ml-2 rounded-md bg-red-100 px-2 py-1 text-xs font-medium text-red-700">
                Test System
              </div>
            </div>
          )}
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight">
            Reset your password
          </h2>
        </div>

        <form className="space-y-6" action="#" method="POST">
          <div className="relative -space-y-px rounded-md shadow-sm">
            <div className="pointer-events-none absolute inset-0 rounded-md ring-1 ring-inset ring-gray-300" />
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  type="email"
                  id="email-address"
                  name="email"
                  autoComplete="email"
                  required
                  placeholder="Email address"
                  onChange={emailChange}
                  className="relative block bg-white/5 w-full rounded-md border-0 py-1.5 ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"                />
              </div>
            </div>
            <div className="relative -space-y-px rounded-md shadow-sm">
              <div className="pointer-events-none absolute inset-0 rounded-md ring-1 ring-inset ring-gray-300" />
                <div>
                  <input 
                    type="password"
                    id="email-address"
                    name="email"
                    autoComplete="email"
                    required
                    placeholder="New password"
                    onChange={passwordChange}
                    className="relative block bg-white/5 w-full rounded-t-md border-0 py-1.5 ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6" />
                    </div>
                <div>
                  <input 
                  type="password"
                  id="email-address"
                  name="email"
                  autoComplete="email"
                  required
                  placeholder="Confirm new password"
                  onChange={confirmPasswordChange}
                  className="relative block bg-white/5 w-full rounded-b-md border-0 py-1.5 ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:z-10 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6" />
                  </div>
              </div>
              <div>
                <PasswordStrengthChecker password={password} passwordSecure={setPasswordSecure}/>
              </div>
            <div className="mt-6">
                {loadingspinner ?
                  <button type='button' className="flex justify-center w-full justify-center rounded-md bg-blue-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700">
                      <div role="status">
                          <svg aria-hidden="true" className="mr-2 w-8 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                          </svg>
                      </div>
                  </button>
                :
                  <button type='button' onClick={() => {resetPW();}} className="h-6flex w-full justify-center rounded-md bg-blue-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700">
                      Reset Password
                  </button>
                }
            </div>
        </form>
        <Modal
        isOpen={accessibilityModal}
        //onAfterOpen={afterOpenModal}
        onRequestClose={() => {setAccessibilityModal(false)}}
        className="my-20 mx-2 pb-12 md:mx-40 overflow-y-auto overflow-x-hidden fixed right-0 left-0 z-50 justify-center items-center h-modal h-full"
        contentLabel="Accessibility Options">
            <div>

                <div className={"rounded-2xl border overflow-auto p-10 " + (themeCSS.divCSS)}>
                    <div className="flex flex-col items-center space-y-2">
                        <h1 className={"font-bold text-2xl w-4/6 text-center " + (themeCSS.divCSS)}>Accessibility Settings</h1>
                        <p className={"text-sm text-center w-5/6 " + (themeCSS.divCSS)}>You can switch between different themes to get a better experience using our portal.</p>
                        <div className="grid grid-cols-1 md:grid-cols-2 w-full md:space-x-4 space-y-2 md:space-y-0">
                            <div>
                            </div>
                            <div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 w-full md:space-x-4 space-y-2 md:space-y-0">
                            <div>
                            </div>
                            <div>
                            </div>
                        </div>
                        
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-1">
                        <button className="btn btn-natural rounded-md font-semibold mb-4 bg-white text-slate-800 hover:text-white" onClick={() => {updateTheme('light')}}>Light Mode</button>
                        <button className="btn btn-natural text-white rounded-md font-semibold mb-4 bg-slate-800" onClick={() => {updateTheme('dark')}}>Dark Mode</button>
                        <button className="btn btn-natural border-0 rounded-md font-semibold mb-4 bg-yellow-300 text-red-500" onClick={() => {updateTheme('highContrast')}}>High Contrast Mode</button>
                    </div>
                    
                </div>
            </div>
        </Modal>
      </div>
    </div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
    </>
  )
}
